import { gql } from '@apollo/client';

import { VideListItemFragment } from '../fragments/videoListFragment';

export default gql`
  query VideosBySubject($courseId: String, $subjectId: String!) {
    videos(courseId: $courseId, subjectId: $subjectId) @rest(type: "Video", path: "courses/{args.courseId}/subjects/{args.subjectId}/videos") {
      ...VideoListItem
    }
  }
  ${VideListItemFragment}
`;
